import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";


export const getEncabezado = async(dates) =>{
    const result = await PrivateInterceptor('Finanzas/NotasProveedor/EncabezadoPorFechas','POST' ,{FechaInicio: dates[0],FechaFinal: dates[1] })
    return result
}
export const getDetalles = async(dates) =>{
    const result = await PrivateInterceptor('Finanzas/NotasProveedor/DetallesPorFechas','POST' ,{FechaInicio: dates[0],FechaFinal: dates[1] })
    return result
}

export const getEncabezadoPorId = async(IdNotaCreditoEnc) =>{
    const result = await PrivateInterceptor('Finanzas/NotasProveedor/getEncabezado','POST', {IdNotaCreditoEnc} )
    return result
}

export const getDetallesPorId = async(IdNotaCreditoEnc) =>{
    const result = await PrivateInterceptor('Finanzas/NotasProveedor/getDetalles','POST', {IdNotaCreditoEnc} )
    return result
}

export const getIngresos = async (IdTipoIngreso, IdVendor) => {
    const respuesta = PrivateInterceptor('Finanzas/NotasProveedor/getIngresos', 'POST', {IdTipoIngreso, IdVendor})
    return respuesta
};

export const GuardarNotaCreditoProveedor = async (Encabezado, Detalles) => {
    const respuesta = PrivateInterceptor("Finanzas/NotasProveedor/GuardarNotaCreditoProveedor", "POST",{Encabezado, Detalles});
    return respuesta;
};

export const EditarNotaCreditoProveedor = async (Encabezado, Detalles) => {
    const respuesta = PrivateInterceptor("Finanzas/NotasProveedor/EditarNotaCreditoProveedor", "POST",{Encabezado, Detalles});
    return respuesta;
};

export const eliminarDetalles = async(Ids) =>{
    const result = await PrivateInterceptor('Finanzas/NotasProveedor/eliminarDetalles','POST' ,{Ids})
    return result
}

export const eliminarNotaCompleta = async(Ids) =>{
    const result = await PrivateInterceptor('Finanzas/NotasProveedor/eliminarNotaCompleta','POST' ,{Ids})
    return result
}

export const AplicarNota = async(datos) =>{
    const result = await PrivateInterceptor(`Finanzas/NotasProveedor/AplicarNota`, 'POST' , datos)
    return result
}

export const PagarNotas = async (Encabezado) => {
    const respuesta = PrivateInterceptor("Finanzas/NotasProveedor/PagarNotas", "POST",{Encabezado});
    return respuesta;
};